<template>
  <v-navigation-drawer
    :value="drawerState"
    :permanent="!mobile"
    :temporary="mobile"
    width="300"
    class="elevation-5"
    @input="onDrawerInput"
  >
    <div class="left_nav">
      <div class="prevent_click_outside" v-if="preventClickOutside"></div>
      <div v-if="$hasGranularPermission('info', 'add')" class="text-xs-center pt-4 pb-2" style="background: #FAFAFA;">
        <router-link :to="{ name: 'ImoveisAdicionar' }">
          <v-btn class="secondary">Cadastrar Imóvel</v-btn>
        </router-link>
      </div>
      <v-card flat style="background: #FAFAFA;">
        <v-card-title style="padding: 9px 16px;">
          <v-layout row wrap style="width: 100%;">
            <v-flex xs12>
              <v-text-field
                v-model="form.texto"
                placeholder="Busca"
                hide-details
                @input="marcarFiltroAlterado"
                class="borda_laranja"
                append-icon="search"
                :append-icon-cb="setFiltros"
              >
              </v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
      <v-card class="grey lighten-3" flat style="width: 100%;">
        <v-card-title style="padding: 9px 16px;">
          <v-layout row wrap style="width: 100%;">
            <v-flex xs12 sm6>
              <v-btn flat class="remover_padding mx-0 grey" :class="{ 'secondary--text': countFiltros > 0, 'grey--text': countFiltros === 0 }" @click.native="limparFiltros" :disabled="countFiltros === 0">Limpar filtros</v-btn>
            </v-flex>
            <v-flex xs12 sm6 class="text-xs-right">
              <v-btn outline class="mr-0 grey grey--text" @click.native="setFiltros" :disabled="!filtroAlterado">Aplicar</v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
      <v-list>
        <v-list-tile v-if="canShowProprietarioFilter">
          <v-list-tile-content>
            <v-select
              label="Proprietário"
              v-bind:items="proprietarioItems"
              v-model="form.proprietario"
              multiple
              hide-details
              no-data-text="Sem opções disponíveis"
              append-icon="keyboard_arrow_right"
              @click.native="openedSelect"
              @update:searchInput="closedSelect"
              @change="marcarFiltroAlterado"
            >
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="canShowProprietarioFilter"></v-divider>
        <v-list-tile v-if="$hasGranularPermission('info', 'view')">
          <v-list-tile-content>
            <v-select
              label="Tipo"
              v-bind:items="lista.tipo"
              v-model="form.tipo"
              multiple
              hide-details
              no-data-text="Sem opções disponíveis"
              append-icon="keyboard_arrow_right"
              @click.native="openedSelect"
              @update:searchInput="closedSelect"
              @change="marcarFiltroAlterado"
            >
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="$hasGranularPermission('info', 'view')"></v-divider>
        <v-list-tile v-if="$hasGranularPermission('endereco', 'view')">
          <v-list-tile-content>
            <v-select
              label="Estado"
              v-bind:items="Object.keys(lista.uf)"
              v-model="form.uf"
              multiple
              hide-details
              no-data-text="Sem opções disponíveis"
              append-icon="keyboard_arrow_right"
              @click.native="openedSelect"
              @update:searchInput="closedSelect"
              @change="marcarFiltroAlterado"
            >
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="$hasGranularPermission('endereco', 'view')"></v-divider>
        <v-list-tile v-if="form.uf.length > 0">
          <v-list-tile-content>
            <v-select
              label="Cidade"
              v-bind:items="Object.keys(lista.cidade).sort()"
              v-model="form.cidade"
              multiple
              hide-details
              no-data-text="Sem opções disponíveis"
              append-icon="keyboard_arrow_right"
              @click.native="openedSelect"
              @update:searchInput="closedSelect"
              @change="marcarFiltroAlterado"
            >
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="form.uf.length > 0"></v-divider>
        <v-list-tile v-if="form.cidade.length > 0">
          <v-list-tile-content>
            <v-select
              label="Bairro"
              v-bind:items="lista.bairro"
              v-model="form.bairro"
              multiple
              hide-details
              no-data-text="Sem opções disponíveis"
              append-icon="keyboard_arrow_right"
              @click.native="openedSelect"
              @update:searchInput="closedSelect"
              @change="marcarFiltroAlterado"
            >
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="form.cidade.length > 0"></v-divider>
        <v-list-tile v-if="$hasGranularPermission('endereco', 'view')">
          <v-list-tile-content>
            <v-select
              label="Em loteamento"
              v-bind:items="lista.com_loteamento"
              v-model="form.com_loteamento"
              hide-details
              no-data-text="Sem opções disponíveis"
              append-icon="keyboard_arrow_right"
              @click.native="openedSelect"
              @update:searchInput="closedSelect"
              @change="marcarFiltroAlterado"
            >
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="$hasGranularPermission('endereco', 'view')"></v-divider>
        <v-list-tile v-if="form.com_loteamento === 1">
          <v-list-tile-content>
            <v-select
              label="Selecionar loteamento"
              v-bind:items="lista.loteamento"
              v-model="form.loteamento"
              multiple
              hide-details
              no-data-text="Sem opções disponíveis"
              append-icon="keyboard_arrow_right"
              @click.native="openedSelect"
              @update:searchInput="closedSelect"
              @change="marcarFiltroAlterado"
            >
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="form.com_loteamento === 1"></v-divider>
        <v-list-group no-action v-model="opcoes.lote" v-if="form.com_loteamento === 1">
          <v-list-tile slot="item">
            <v-list-tile-content>
              <v-list-tile-title>Lote e quadra</v-list-tile-title>
              <div class="selecionados" v-if="!opcoes.lote && (form.lote.length > 0 || form.quadra.length > 0)">
                <template v-if="form.lote.length > 0">Lote {{ form.lote }}</template>
                <template v-if="form.lote.length > 0 && form.quadra.length > 0"> - </template>
                <template v-if="form.quadra.length > 0">Quadra {{ form.quadra }}</template>
              </div>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>keyboard_arrow_right</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-flex xs11 offset-xs1 style="padding-left: 11px;">
                <div class="body-2 pt-2">Lote</div>
                <v-layout row wrap style="width: 100%; margin-top:-10px;">
                  <v-flex xs12>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.lote"
                      name="lote"
                      hide-details
                      class="pb-0"
                      @input="marcarFiltroAlterado"
                    >
                    </v-text-field>
                  </v-flex>
                  <div class="body-2 pt-4">Quadra</div>
                  <v-flex xs12>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.quadra"
                      name="quadra"
                      hide-details
                      class="pb-0"
                      @input="marcarFiltroAlterado"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-divider v-if="form.com_loteamento === 1"></v-divider>
        <v-list-group no-action v-model="opcoes.status">
          <v-list-tile slot="item" v-if="$hasGranularPermission('status', 'view')">
            <v-list-tile-content>
              <v-list-tile-title>Status</v-list-tile-title>
              <div class="selecionados" v-if="!opcoes.status && form.status.length > 0">
                {{ form.status.join(', ') }}
              </div>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>keyboard_arrow_right</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-layout row wrap style="width: 100%;">
                <v-flex xs12>
                  <v-checkbox
                    class="status_checkbox"
                    label="Vago"
                    v-model="form.status"
                    color="secondary"
                    value="Vago"
                    hide-details
                    @change="resetarFilhos('Vago'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex xs11 offset-xs1 style="padding-left: 11px;">
                  <v-select
                    label="Com placa"
                    v-bind:items="lista.vago_com_placa"
                    v-model="form.vago_com_placa"
                    hide-details
                    no-data-text="Sem opções disponíveis"
                    append-icon="keyboard_arrow_right"
                    @click.native="openedSelect"
                    @update:searchInput="closedSelect"
                    @change="marcarStatus($event, 'Vago'); marcarFiltroAlterado();"
                  >
                  </v-select>
                  <div class="body-2 py-2">Nível de segurança</div>
                  <v-checkbox
                    label="Seguro"
                    v-model="form.vago_seguranca"
                    color="secondary"
                    value="Seguro"
                    hide-details
                    @change="marcarStatus($event, 'Vago'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                  <v-checkbox
                    label="Média segurança"
                    v-model="form.vago_seguranca"
                    color="secondary"
                    value="Média segurança"
                    hide-details
                    @change="marcarStatus($event, 'Vago'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                  <v-checkbox
                    label="Inseguro"
                    v-model="form.vago_seguranca"
                    color="secondary"
                    value="Inseguro"
                    hide-details
                    @change="marcarStatus($event, 'Vago'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex xs12 class="py-3">
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="width: 100%;">
                <v-flex xs12>
                  <v-checkbox
                    class="status_checkbox"
                    label="Compromissado"
                    v-model="form.status"
                    color="secondary"
                    value="Compromissado"
                    hide-details
                    @change="resetarFilhos('Compromissado'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex xs11 offset-xs1 style="padding-left: 11px;">
                  <v-checkbox
                    label="Em dia"
                    v-model="form.compromissado_condicao"
                    color="secondary"
                    value="Em dia"
                    hide-details
                    @change="marcarStatus($event, 'Compromissado'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                  <v-checkbox
                    label="Quitado sem escritura"
                    v-model="form.compromissado_condicao"
                    color="secondary"
                    value="Quitado sem escritura"
                    hide-details
                    @change="marcarStatus($event, 'Compromissado'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                  <v-checkbox
                    label="Com escritura definitiva"
                    v-model="form.compromissado_condicao"
                    color="secondary"
                    value="Com escritura definitiva"
                    hide-details
                    @change="marcarStatus($event, 'Compromissado'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                  <v-checkbox
                    label="Inadimplente"
                    v-model="form.compromissado_condicao"
                    color="secondary"
                    value="Inadimplente"
                    hide-details
                    @change="marcarStatus($event, 'Compromissado'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                  <v-checkbox
                    label="Inadimplente ajuizado"
                    v-model="form.compromissado_condicao"
                    color="secondary"
                    value="Inadimplente ajuizado"
                    hide-details
                    @change="marcarStatus($event, 'Compromissado'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex xs12 class="py-3">
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="width: 100%;">
                <v-flex xs12>
                  <v-checkbox
                    class="status_checkbox"
                    label="Locado"
                    v-model="form.status"
                    color="secondary"
                    value="Locado"
                    hide-details
                    @change="resetarFilhos('Locado'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex xs11 offset-xs1 style="padding-left: 11px;" v-if="$auth.check('Administrador')">
                  <v-checkbox
                    label="Em dia"
                    v-model="form.locado_condicao"
                    color="secondary"
                    value="Em dia"
                    hide-details
                    @change="marcarStatus($event, 'Locado'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                  <v-checkbox
                    label="Inadimplente"
                    v-model="form.locado_condicao"
                    color="secondary"
                    value="Inadimplente"
                    hide-details
                    @change="marcarStatus($event, 'Locado'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                  <v-checkbox
                    label="Inadimplente ajuizado"
                    v-model="form.locado_condicao"
                    color="secondary"
                    value="Inadimplente ajuizado"
                    hide-details
                    @change="marcarStatus($event, 'Locado'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                  <v-divider class="mt-3"></v-divider>
                  <v-select
                    label="Com ação renovatória"
                    v-bind:items="lista.locado_acao_renovatoria"
                    v-model="form.locado_acao_renovatoria"
                    hide-details
                    no-data-text="Sem opções disponíveis"
                    append-icon="keyboard_arrow_right"
                    @click.native="openedSelect"
                    @update:searchInput="closedSelect"
                    @change="marcarStatus($event, 'Locado'); marcarFiltroAlterado();"
                  >
                  </v-select>
                  <v-divider class="mt-1 mb-3"></v-divider>
                  <v-select
                    label="Índice"
                    v-bind:items="lista.locado_indice"
                    v-model="form.locado_indice"
                    hide-details
                    no-data-text="Sem opções disponíveis"
                    append-icon="keyboard_arrow_right"
                    @click.native="openedSelect"
                    @update:searchInput="closedSelect"
                    @change="marcarStatus($event, 'Locado'); marcarFiltroAlterado();"
                  >
                  </v-select>
                  <v-divider class="mt-1 mb-3"></v-divider>
                  <div class="body-2 pt-2">Valor do aluguel (R$)</div>
                  <v-layout row wrap style="width: 100%; margin-top:-10px;">
                    <v-flex xs12 sm6>
                      <v-text-field
                        autocomplete="off"
                        type="number"
                        v-model="form.locado_valor_minimo"
                        name="locado_valor_minimo"
                        @input="marcarStatus($event, 'Locado'); marcarFiltroAlterado();"
                        hide-details
                        class="pb-0"
                      >
                      </v-text-field>
                      <small>(Mín.)</small>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        autocomplete="off"
                        type="number"
                        v-model="form.locado_valor_maximo"
                        name="locado_valor_maximo"
                        @input="marcarStatus($event, 'Locado'); marcarFiltroAlterado();"
                        hide-details
                        class="pb-0"
                      >
                      </v-text-field>
                      <small>(Máx.)</small>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs12 class="py-3">
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="width: 100%;">
                <v-flex xs12>
                  <v-checkbox
                    class="status_checkbox"
                    label="Comodato"
                    v-model="form.status"
                    color="secondary"
                    value="Comodato"
                    hide-details
                    @change="marcarFiltroAlterado"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex xs12 class="py-3">
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
              <v-layout row wrap style="width: 100%;">
                <v-flex xs12>
                  <v-checkbox
                    class="status_checkbox"
                    label="Invadido"
                    v-model="form.status"
                    color="secondary"
                    value="Invadido"
                    hide-details
                    @change="resetarFilhos('Invadido'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                </v-flex>
                <v-flex xs11 offset-xs1 style="padding-left: 11px;">
                  <v-checkbox
                    label="Ocupado irregularmente"
                    v-model="form.invadido_condicao"
                    color="secondary"
                    value="Ocupado irregularmente"
                    hide-details
                    @change="marcarStatus($event, 'Invadido'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                  <v-checkbox
                    label="Ocupado ajuizado"
                    v-model="form.invadido_condicao"
                    color="secondary"
                    value="Ocupado ajuizado"
                    hide-details
                    @change="marcarStatus($event, 'Invadido'); marcarFiltroAlterado();"
                  >
                  </v-checkbox>
                </v-flex>
              </v-layout>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-divider v-if="$hasGranularPermission('status', 'view')"></v-divider>
        <v-list-group no-action v-model="opcoes.area">
          <v-list-tile slot="item" v-if="$hasGranularPermission('area', 'view')">
            <v-list-tile-content>
              <v-list-tile-title>Área</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>keyboard_arrow_right</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-flex xs11 offset-xs1 style="padding-left: 11px;">
                <div class="body-2 pt-2">Área do terreno (m²)</div>
                <v-layout row wrap style="width: 100%; margin-top:-10px;">
                  <v-flex xs12 sm6>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.area_terreno_minima"
                      name="area_terreno_minima"
                      hide-details
                      class="pb-0"
                      @input="marcarFiltroAlterado"
                    >
                    </v-text-field>
                    <small>(Mín.)</small>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.area_terreno_maxima"
                      name="area_terreno_maxima"
                      hide-details
                      class="pb-0"
                      @input="marcarFiltroAlterado"
                    >
                    </v-text-field>
                    <small>(Máx.)</small>
                  </v-flex>
                </v-layout>
                <div class="body-2 pt-4">Área construída (m²)</div>
                <v-layout row wrap style="width: 100%; margin-top:-10px;">
                  <v-flex xs12 sm6>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.area_construida_minima"
                      name="area_construida_minima"
                      hide-details
                      class="pb-0"
                      @input="marcarFiltroAlterado"
                    >
                    </v-text-field>
                    <small>(Mín.)</small>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.area_construida_maxima"
                      name="area_construida_maxima"
                      hide-details
                      class="pb-0"
                      @input="marcarFiltroAlterado"
                    >
                    </v-text-field>
                    <small>(Máx.)</small>
                  </v-flex>
                </v-layout>
                <div class="body-2 pt-4">Área útil (m²)</div>
                <v-layout row wrap style="width: 100%; margin-top:-10px;">
                  <v-flex xs12 sm6>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.area_util_minima"
                      name="area_util_minima"
                      hide-details
                      class="pb-0"
                      @input="marcarFiltroAlterado"
                    >
                    </v-text-field>
                    <small>(Mín.)</small>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      autocomplete="off"
                      v-model="form.area_util_maxima"
                      name="area_util_maxima"
                      hide-details
                      class="pb-0"
                      @input="marcarFiltroAlterado"
                    >
                    </v-text-field>
                    <small>(Máx.)</small>
                  </v-flex>
                </v-layout>
                <v-divider class="mt-4 mb-3"></v-divider>
                <v-select
                  label="Com calçada"
                  v-bind:items="lista.com_calcada"
                  v-model="form.com_calcada"
                  hide-details
                  no-data-text="Sem opções disponíveis"
                  append-icon="keyboard_arrow_right"
                  @click.native="openedSelect"
                  @update:searchInput="closedSelect"
                  @change="marcarFiltroAlterado"
                >
                </v-select>
                <v-select
                  label="Com muro"
                  v-bind:items="lista.com_muro"
                  v-model="form.com_muro"
                  hide-details
                  no-data-text="Sem opções disponíveis"
                  append-icon="keyboard_arrow_right"
                  @click.native="openedSelect"
                  @update:searchInput="closedSelect"
                  @change="marcarFiltroAlterado"
                >
                </v-select>
              </v-flex>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-divider v-if="$hasGranularPermission('area', 'view')"></v-divider>
        <v-list-tile v-if="$hasGranularPermission('taxas', 'view')">
          <v-list-tile-content>
            <v-select
              label="IPTU"
              v-bind:items="lista.iptu_condicao"
              v-model="form.iptu_condicao"
              multiple
              hide-details
              no-data-text="Sem opções disponíveis"
              append-icon="keyboard_arrow_right"
              @click.native="openedSelect"
              @update:searchInput="closedSelect"
              @change="marcarFiltroAlterado"
            >
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="$hasGranularPermission('taxas', 'view')"></v-divider>
        <v-list-group no-action v-model="opcoes.valor" v-if="$hasGranularPermission('valor', 'view')">
          <v-list-tile slot="item" v-if="$hasGranularPermission('valor', 'view')">
            <v-list-tile-content>
              <v-list-tile-title>Valor</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>keyboard_arrow_right</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-content>
              <v-flex xs11 offset-xs1 style="padding-left: 11px;">
                <div class="body-2 pt-2">Estimativa do valor (R$)</div>
                <v-layout row wrap style="width: 100%; margin-top:-10px;">
                  <v-flex xs12 sm6>
                    <v-text-field
                      autocomplete="off"
                      type="number"
                      v-model="form.estimativa_valor_minimo"
                      name="estimativa_valor_minimo"
                      hide-details
                      class="pb-0"
                      @input="marcarFiltroAlterado"
                    >
                    </v-text-field>
                    <small>(Mín.)</small>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      autocomplete="off"
                      type="number"
                      v-model="form.estimativa_valor_maximo"
                      name="estimativa_valor_maximo"
                      hide-details
                      class="pb-0"
                      @input="marcarFiltroAlterado"
                    >
                    </v-text-field>
                    <small>(Máx.)</small>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>
        <v-divider v-if="$hasGranularPermission('valor', 'view')"></v-divider>
        <v-list-tile v-if="$hasGranularPermission('vistoria', 'view')">
          <v-list-tile-content>
            <v-select
              label="Vistoria"
              v-bind:items="lista.vistoria"
              v-model="form.vistoria"
              multiple
              hide-details
              no-data-text="Sem opções disponíveis"
              append-icon="keyboard_arrow_right"
              @click.native="openedSelect"
              @update:searchInput="closedSelect"
              @change="marcarFiltroAlterado"
            >
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="$hasGranularPermission('vistoria', 'view')"></v-divider>
        <v-list-tile v-if="$hasGranularPermission('tarefas', 'view')">
          <v-list-tile-content>
            <v-select
              label="Com tarefas pendentes"
              v-bind:items="lista.tarefas_pendentes"
              v-model="form.tarefas_pendentes"
              hide-details
              no-data-text="Sem opções disponíveis"
              append-icon="keyboard_arrow_right"
              @click.native="openedSelect"
              @update:searchInput="closedSelect"
              @change="marcarFiltroAlterado"
            >
            </v-select>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider v-if="$hasGranularPermission('tarefas', 'view')"></v-divider>
      </v-list>
      <v-card class="grey lighten-3" flat style="width: 100%; align-self: flex-end;">
        <v-card-title style="padding: 9px 16px;">
          <v-layout row wrap style="width: 100%;">
            <v-flex xs12 sm6>
              <v-btn flat class="remover_padding mx-0 grey" :class="{ 'secondary--text': countFiltros > 0, 'grey--text': countFiltros === 0 }" @click.native="limparFiltros" :disabled="countFiltros === 0">Limpar filtros</v-btn>
            </v-flex>
            <v-flex xs12 sm6 class="text-xs-right">
              <v-btn outline  class="mr-0 grey grey--text" @click.native="setFiltros" :disabled="!filtroAlterado">Aplicar</v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
      </v-card>
    </div>
  </v-navigation-drawer>
</template>

<script>
  import _ from 'lodash'

  function initialForm () {
    return {
      texto: '',
      proprietario: [],
      tipo: [],
      uf: [],
      cidade: [],
      bairro: [],
      com_loteamento: '',
      loteamento: [],
      lote: '',
      quadra: '',
      status: [],
      vago_com_placa: '',
      vago_seguranca: [],
      compromissado_condicao: [],
      locado_condicao: [],
      locado_acao_renovatoria: '',
      locado_indice: '',
      locado_valor_minimo: '',
      locado_valor_maximo: '',
      invadido_condicao: [],
      area_terreno_minima: '',
      area_terreno_maxima: '',
      area_construida_minima: '',
      area_construida_maxima: '',
      area_util_minima: '',
      area_util_maxima: '',
      com_calcada: '',
      com_muro: '',
      iptu_condicao: [],
      estimativa_valor_minimo: '',
      estimativa_valor_maximo: '',
      vistoria: [],
      tarefas_pendentes: ''
    }
  }

  function normalizeProprietarioValue (item) {
    if (item && typeof item === 'object') {
      if (typeof item.value !== 'undefined' && item.value !== null && item.value !== '') return String(item.value)
      if (typeof item.text !== 'undefined' && item.text !== null && item.text !== '') return String(item.text)
      if (typeof item.nome !== 'undefined' && item.nome !== null && item.nome !== '') return String(item.nome)
      if (typeof item.name !== 'undefined' && item.name !== null && item.name !== '') return String(item.name)
      if (typeof item.id !== 'undefined' && item.id !== null && item.id !== '') return String(item.id)
    }

    if (item === null || typeof item === 'undefined' || item === '') return null
    return String(item)
  }

  function dedupeProprietarios (items) {
    return _.uniqBy(items, normalizeProprietarioValue)
  }

  export default {
    props: {
      mobile: {
        type: Boolean,
        default: false
      },
      drawer: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        preventClickOutside: false,
        filtroAlterado: false,
        opcoes: {
          lote: false,
          status: false,
          area: false,
          valor: false
        },
        form: initialForm()
      }
    },
    computed: {
      currentUser () {
        if (!this.$auth || typeof this.$auth.user !== 'function') return null
        return this.$auth.user()
      },
      drawerState () {
        if (this.mobile) {
          return this.drawer
        }
        return true
      },
      countFiltros () {
        if (!_.isEqual(this.form, initialForm())) {
          return 1
        } else {
          return 0
        }
      },
      canShowProprietarioFilter () {
        return this.$hasGranularPermission('info', 'view')
      },
      isLimitadoProprietario () {
        return this.$hasUserRestrictionFlag('limitado_proprietario')
      },
      isLimitadoTarefas () {
        return this.$hasUserRestrictionFlag('limitado_tarefas')
      },
      allowedRoleProprietarios () {
        const user = this.currentUser || {}
        const directOwners = _.get(user, 'proprietarios', [])
        const customRoleOwners = _.get(user, 'custom_role.proprietarios', [])

        return _.compact(
          _.flatten([
            _.isArray(directOwners) ? directOwners : [],
            _.isArray(customRoleOwners) ? customRoleOwners : []
          ]).map(normalizeProprietarioValue)
        )
      },
      proprietarioItems () {
        const storeItems = _.get(this.$store.getters, 'imoveis/listaFiltros.proprietario', [])
        const allItems = _.isArray(storeItems) ? storeItems : []

        if (this.isLimitadoProprietario) {
          const allowedOwners = new Set(this.allowedRoleProprietarios)

          if (allowedOwners.size < 1) {
            return []
          }

          const filteredItems = allItems.filter((item) => allowedOwners.has(normalizeProprietarioValue(item)))
          if (filteredItems.length > 0) {
            return dedupeProprietarios(filteredItems)
          }

          return dedupeProprietarios(Array.from(allowedOwners))
        }

        if (this.isLimitadoTarefas) {
          return dedupeProprietarios(allItems)
        }

        return dedupeProprietarios(allItems)
      },
      lista () {
        return {
          proprietario: this.proprietarioItems,
          tipo: this.$store.getters['imoveis/listaFiltros']['tipo'],
          uf: this.$store.getters['imoveis/listaFiltros']['uf'],
          cidade: [],
          bairro: [],
          com_loteamento: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }],
          loteamento: this.$store.getters['imoveis/listaFiltros']['loteamento'],
          vago_com_placa: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }],
          locado_acao_renovatoria: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }],
          locado_indice: [{ text: 'Indiferente', value: '' }, { text: 'Satisfatório', value: 1 }, { text: 'Insatisfatório', value: 0 }],
          com_calcada: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }],
          com_muro: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }],
          iptu_condicao: ['Quitado / em dia', 'Pendente', 'Pendente ajuizado'],
          vistoria: ['Sem vistoria', 'Em dia', 'Próxima', 'Atrasada', 'Vistoria realizada'],
          tarefas_pendentes: [{ text: 'Indiferente', value: '' }, { text: 'Sim', value: 1 }, { text: 'Não', value: 0 }]
        }
      }
    },
    watch: {
      'form.com_loteamento': function (value) {
        if (value !== 1) {
          this.form.loteamento = []
        }
      },
      'form.uf': function (value) {
        const novaLista = []
        const cidades = []
        value.forEach((itemUf) => {
          Object.keys(this.lista.uf[itemUf]).forEach((itemCidade) => {
            novaLista[itemCidade] = this.lista.uf[itemUf][itemCidade]
            cidades.push(itemCidade)
          })
        })
        this.form.cidade = _.intersection(cidades, this.form.cidade)
        this.lista.cidade = novaLista
      },
      'form.cidade': function (value) {
        const novaLista = []
        value.forEach((itemCidade) => {
          novaLista.push(this.lista.cidade[itemCidade])
        })
        this.lista.bairro = _.uniq(_.flatten(novaLista).sort())
        this.form.bairro = _.intersection(this.lista.bairro, this.form.bairro)
      },
      proprietarioItems: function (items) {
        const allowedValues = new Set(_.compact(items.map(normalizeProprietarioValue)))
        this.form.proprietario = this.form.proprietario.filter((item) => allowedValues.has(normalizeProprietarioValue(item)))
      },
      'form.area_terreno_minima': function (value) {
        this.form.area_terreno_minima = this.formatArea(value)
      },
      'form.area_terreno_maxima': function (value) {
        this.form.area_terreno_maxima = this.formatArea(value)
      },
      'form.area_construida_minima': function (value) {
        this.form.area_construida_minima = this.formatArea(value)
      },
      'form.area_construida_maxima': function (value) {
        this.form.area_construida_maxima = this.formatArea(value)
      },
      'form.area_util_minima': function (value) {
        this.form.area_util_minima = this.formatArea(value)
      },
      'form.area_util_maxima': function (value) {
        this.form.area_util_maxima = this.formatArea(value)
      },
      'form': {
        handler: function () {
          if (this.filtroAlterado === false) {
            this.marcarFiltroAlterado
          }
        },
        deep: true
      }
    },
    mounted () {
      this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'imoveis/CLEAR_FILTROS') {
          this.limparFiltros()
        }
      })
    },
    methods: {
      onDrawerInput (value) {
        if (this.mobile) {
          this.$emit('update:drawer', value)
        }
      },
      formatArea (area) {
        if (area === null) {
          return ''
        }

        let value = area
        let newValue = String(value).replace(/\./g, '').replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')

        return newValue
      },
      resetarFilhos (campo) {
        if (_.indexOf(this.form.status, campo) < 0) {
          const status = campo.toLowerCase()
          const filhos = _.pickBy(this.form, function (value, key) {
            return key.startsWith(status)
          })
          _.forEach(filhos, (value, key) => {
            this.form[key] = (_.isArray(this.form[key]) ? [] : '')
          })
        }
      },
      marcarStatus (event, status) {
        if ((!_.isArray(event) && event !== null && event !== '') || (_.isArray(event) && !_.isEmpty(event)) && !_.includes(this.form.status, status)) {
          this.form.status.push(status)
        }
      },
      limparFiltros () {
        this.form = initialForm()
        this.$store.dispatch('imoveis/setFiltros', {})
        this.filtroAlterado = false
      },
      marcarFiltroAlterado () {
        this.filtroAlterado = true
        // this.setFiltros()
      },
      setFiltros () {
        const payload = _.omitBy(_.omitBy(this.form, _.isNull), (item) => item.length === 0)

        if (_.has(payload, 'area_terreno_minima')) {
          payload.area_terreno_minima = parseInt(payload.area_terreno_minima.replace(/\./g, ''))
        }

        if (_.has(payload, 'area_terreno_maxima')) {
          payload.area_terreno_maxima = parseInt(payload.area_terreno_maxima.replace(/\./g, ''))
        }

        if (_.has(payload, 'area_construida_minima')) {
          payload.area_construida_minima = parseInt(payload.area_construida_minima.replace(/\./g, ''))
        }

        if (_.has(payload, 'area_construida_maxima')) {
          payload.area_construida_maxima = parseInt(payload.area_construida_maxima.replace(/\./g, ''))
        }

        if (_.has(payload, 'area_util_minima')) {
          payload.area_util_minima = parseInt(payload.area_util_minima.replace(/\./g, ''))
        }

        if (_.has(payload, 'area_util_maxima')) {
          payload.area_util_maxima = parseInt(payload.area_util_maxima.replace(/\./g, ''))
        }

        this.$store.dispatch('imoveis/setFiltros', payload)
        this.filtroAlterado = false

        if (this.mobile) {
          this.$emit('update:drawer', false)
        }
      },
      openedSelect () {
        this.preventClickOutside = true
      },
      closedSelect () {
        // if (this.filtroAlterado) {
        //   this.filtroAlterado = false

        //   const payload = {
        //     proprietario: this.form.proprietario,
        //     tipo: this.form.tipo,
        //     uf: this.form.uf,
        //     cidade: this.form.cidade,
        //     bairro: this.form.bairro,
        //     loteamento: this.form.loteamento
        //   }

        //   this.$store.dispatch('imoveis/loadFiltros', payload)
        // }

        window.setTimeout(() => {
          this.preventClickOutside = false
        }, 100)
      }
    }
  }
</script>

<style>
  .card .list__tile__action { min-width: 36px; }

  .navigation-drawer__border { display: none; }

  .left_nav { display: flex; width: 100%; height: 100%; justify-content: space-between; flex-direction: column; }
  .left_nav .list { padding: 0; flex: 1; }
  .left_nav .list__tile { height: auto; }
  .left_nav .list > li { padding-bottom: 3px; padding-top: 1px; }
  .left_nav .list--group:after { display: none; }
  .left_nav .list--group__container { padding-top: 16px; padding-bottom: 18px; }
  .left_nav .list--group__container .list { padding-top: 10px; }
  .left_nav .list--group__header--active .list__tile .list__tile__action:last-of-type .icon,
  .left_nav .input-group--select.input-group--focused .input-group__append-icon { -webkit-transform: rotate(90deg); transform: rotate(90deg); }
  .left_nav .input-group.input-group--focused .input-group__input .icon { color: #0000008a; }
  .left_nav a.list__tile:hover, .list__tile--highlighted,
  .left_nav .list--group__header--active .list__tile,
  .left_nav .ripple__animation { background: none !important; }
  .left_nav .list__tile:after { background: none !important; }
  .left_nav .input-group--select .input-group__details,
  .left_nav .input-group--selection-controls .input-group__details { display: none; }
  .left_nav .list__tile,
  .left_nav .input-group label { color: #000000 !important; font-size: 14px; }
  .left_nav .list__tile .list__tile__title,
  .left_nav .input-group--select.input-group label { font-weight: 500; }
  .left_nav .radio label { font-weight: 400; }
  .left_nav .input-group--select .input-group__selections__comma { font-size: 13px; color: #737373 !important; }
  .left_nav .input-group--select .input-group__selections { padding-top: 14px; }
  .left_nav .input-group--select.input-group--dirty { padding-bottom: 9px; margin-top: 8px; }
  .left_nav .input-group--select.input-group--dirty:not(.input-group--textarea) label { -webkit-transform: translate3d(0, -12px, 0) scale(1); transform: translate3d(0, -12px, 0) scale(1); }
  .left_nav .input-group.checkbox { padding: 1px 0; }
  .left_nav .status_checkbox label { color: #f37021 !important; font-weight: 500; }
  .left_nav .btn--disabled:not(.btn--icon):not(.btn--flat) { background-color: transparent !important; }

  .remover_padding .btn__content { padding: 0; }

  .borda_laranja .input-group__details:before { background-color: #F37021 !important; }
</style>

<style scoped>
  .prevent_click_outside { position: fixed; top: 0; bottom: 0; left: 0; right: 0; background: none; z-index: 5; }

  .selecionados { color: #737373; font-size: 13px; font-weight: 400; padding-top: 3px; }

  .navigation-drawer { padding-bottom: 0; }

  @media (max-width: 599px) {
    .left_nav .card__title .text-xs-right {
      text-align: left !important;
      margin-top: 6px;
    }

    .left_nav .card__title .btn {
      width: 100%;
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// TemplateLeftNav.vue?d4b4a2c0